import { SvgIconProps } from '@mui/material';

const ThaiFlagIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={18}
      height={18}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <circle cx={10} cy={10} r={9} fill="#D1D1D1" />
    </mask>
    <g mask="url(#a)">
      <path fill="#F2F2F2" d="M0 13h20v3H0z" />
      <path fill="#B60000" d="M0 16h20v3H0z" />
      <path fill="#0064C5" d="M0 7h20v6H0z" />
      <path fill="#F2F2F2" d="M0 4h20v3H0z" />
      <path fill="#B60000" d="M0 1h20v3H0z" />
    </g>
  </svg>
);
export default ThaiFlagIcon;
